import { LitElement, css, html } from "lit";
import { neutral, primary } from "../../../../../../../../legl-ui/lds-colours";
import { elevation } from "../../../../../../../../legl-ui/lds-elevation";
import { spacing } from "../../../../../../../../legl-ui/lds-spacing";
import { typographyPresets } from "../../../../../../../../legl-ui/lds-typography";
import "./multiselect/index.js";

export class LeglLawyersTableSelectFilter extends LitElement {
  static get styles() {
    return css`
            :host {
                ${typographyPresets.medium};
                position: relative;
                min-width: 200px;
            }

            .multiselect-wrapper {
                white-space: nowrap;
            }

            .multiselect-wrapper label {
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            .multiselect-wrapper label:last-child {
                margin-bottom: 0;
            }

            .multiselect-wrapper .multiselect-list {
                z-index: 200;
                width: calc(100% + 20px);
                position: absolute;
                display: none;
                background-color: white;
                border: 1px solid ${neutral["200"]};
                border-bottom-left-radius: 2px;
                border-bottom-right-radius: 2px;
                margin-top: -1px;
                ${elevation["200"]};
            }

            .multiselect-wrapper .multiselect-list label {
                padding: ${spacing.xs} 0;
                align-items: flex-start;
            }

            .multiselect-wrapper .multiselect-list.active {
                display: block;
            }

            .multiselect-wrapper .multiselect-list > span {
                font-weight: bold;
            }

            .multiselect-text {
                word-break: break-all;
                white-space: normal;
            }

            .multiselect-wrapper .multiselect-list .multiselect-checkbox {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
            }

            .multiselect-wrapper .multiselect-list .checkmark {
                display: inline-block;
                position: relative;
                height: 14px;
                width: 14px;
                border: 2px solid ${neutral["700"]};
                border-radius: 4px;
                margin-right: ${spacing.xs};
                flex: 0 0 14px;
                margin-top: 1px;
            }

            .multiselect-wrapper .multiselect-list .checkmark:after {
                content: "";
                position: absolute;
                display: none;
                left: 4px;
                top: 0px;
                width: 4px;
                height: 8px;
                border: solid white;
                border-width: 0 2.5px 2.5px 0;
                -webkit-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
            }

            .multiselect-wrapper
                .multiselect-list
                .multiselect-checkbox:checked
                ~ .checkmark {
                background-color: ${primary["500"]};
                border-color: ${primary["500"]};
            }

            .multiselect-wrapper
                .multiselect-list
                .multiselect-checkbox:checked
                ~ .checkmark:after {
                display: block;
            }

            .multiselect-wrapper ul {
                list-style: none;
                display: block;
                position: relative;
                padding: 0px;
                margin: 0px;
                max-height: 266px;
                overflow-y: auto;
                overflow-x: hidden;
                padding: ${spacing.xs};
            }

            .multiselect-wrapper ul li {
                display: block;
            }

            .multiselect-wrapper ul li:hover {
                background-color: ${neutral["100"]};
            }

            .multiselect-input-div input {
                width: 100%;
                border: 1px solid ${neutral["300"]};
                background: #fff;
                padding: 11px;
                vertical-align: middle;
                ${typographyPresets.body};
                color: ${neutral["800"]};
                border-radius: 4px;
            }

            .multiselect-input-div input:focus {
                outline: ${primary["500"]} solid 1px;
                border-color: ${primary["500"]};
            }

            .multiselect-input-div input::placeholder {
                color: ${neutral["300"]};
            }

            .multiselect-count {
                position: relative;
                text-align: center;
                border-radius: 2px;
                background-color: ${neutral["200"]};
                color: ${neutral["800"]};
                display: inline-block !important;
                padding: 1px 7px;
                left: -45px;
            }

            .multiselect-wrapper.disabled .multiselect-dropdown-arrow {
                border-top: 5px solid lightgray;
            }

            .multiselect-wrapper.disabled .multiselect-count {
                background-color: lightgray;
            }

            .multiselect-dropdown-arrow {
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 5px solid black;
                line-height: 20px;
                text-align: center;
                display: inline-block !important;
                margin-left: -42px;
            }
        `;
  }

  static get properties() {
    return {
      label: { attribute: false },
      data: { attribute: false },
      allowSelectAll: { attribute: false },
      showSelectedValue: { attribute: false },
      onFilter: { attribute: false },
      options: { attribute: false },
      appliedFilters: { attribute: false },
    };
  }

  firstUpdated(changedProperties) {
    $(this.shadowRoot.querySelector(`#multiple-checkboxes-${this.data}`))
      .multiselect(this.shadowRoot)
      .handleCheckboxClick(this.onFilter);
  }

  updated(changedProperties) {
    const oldFilters =
      changedProperties.get("appliedFilters")?.filters[this.data] || [];
    const newFilters = this.appliedFilters?.filters[this.data] || [];
    const removedFilters = oldFilters.filter(
      (oldFilter) => !newFilters.includes(oldFilter),
    );
    if (removedFilters.length) {
      removedFilters.forEach((removedFilter) => {
        $(this.shadowRoot.querySelector(`#multiple-checkboxes-${this.data}`))
          .multiselect(this.shadowRoot)
          .deselect(removedFilter);
      });
    } else {
      newFilters.forEach((newFilter) => {
        $(this.shadowRoot.querySelector(`#multiple-checkboxes-${this.data}`))
          .multiselect(this.shadowRoot)
          .select(newFilter);
      });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.shadowRoot.querySelector(`#multiple-checkboxes-${this.data}`)) {
      $(this.shadowRoot.querySelector(`#multiple-checkboxes-${this.data}`))
        .multiselect(this.shadowRoot)
        .destroy();
    }
  }

  render() {
    return html`
            <select
                id="multiple-checkboxes-${this.data}"
                multiple
                .label=${this.label}
                .allowSelectAll=${this.allowSelectAll}
                .showSelectedValue=${this.showSelectedValue}
            >
                ${this.options?.map(
                  (option) =>
                    html`<option .value=${option.value}>
                            ${option.label}
                        </option>`,
                )}
            </select>
        `;
  }
}

if (!customElements.get("legl-lawyers-table-select-filter")) {
  customElements.define(
    "legl-lawyers-table-select-filter",
    LeglLawyersTableSelectFilter,
  );
}
